module.exports = __webpack_public_path__ + "img/页面图片修改2-5.d478ad4e.png";